export default "__VITE_ASSET__nCOiLHAM__"